import type { FTCDisclosure } from "@expert/contentful";
import { Button, Checkbox, Divider, Flex, Text } from "@mantine/core";
import { usePartner } from "@/sdk";
import { useFeatureFlag } from "@/shared-utils";

export const DisclosuresMap = ({
    requiresNyDisclosures,
    FTCDisclosures,
}: {
    requiresNyDisclosures: boolean;
    FTCDisclosures?: FTCDisclosure;
}) => {
    const partner = usePartner();
    const { data: isFTCDisclosuresEnabled, isLoading } = useFeatureFlag("isFTCDisclosuresEnabled", {
        partner: partner,
    });
    if (isLoading) {
        return null;
    }
    if (!FTCDisclosures) {
        return <Flex>{`There are currently no disclosures available for this product`}</Flex>;
    }
    if (!isFTCDisclosuresEnabled) {
        return (
            <Flex gap="1.5rem">
                <Flex gap="1rem" direction="column">
                    <GenericSection
                        label=""
                        content="Asurion Home+ costs $24.99 plus tax per month and automatically renews each month until canceled. It is an optional product that you may cancel at any time."
                    />
                    <GenericSection
                        label=""
                        content="The plan offers repairs, replacements or reimbursement on eligible tech products in your home. It covers product breakdowns and accidental damage from handling on certain devices. The plan is not insurance and does not cover phones."
                    />
                    <GenericSection
                        label=""
                        content="The plan offers tech support on Day 1. Other coverage starts on Day 31. Pre-existing conditions are not covered. A service fee of up to $99 plus tax applies for each approved claim. The claims limits are $2,000 per claim and $5,000 for all claims within a 12-month period."
                    />
                    <GenericSection
                        label=""
                        content="Limitations and exclusions apply. Review full Terms and Conditions at asur.me/homeplusterms, which have an arbitration provision for disputes, including a class action waiver."
                    />
                    <Checkbox disabled label="I have read and agree to the key disclosures and Terms & Conditions." />
                    <Button disabled>Continue to Payment</Button>
                </Flex>
            </Flex>
        );
    } else {
        return (
            <Flex gap="1.5rem" direction="column" w="100%">
                <Text size="lg">Enrollment and cancelation</Text>
                <Checkbox disabled label={<Text>{FTCDisclosures.checkbox1text}</Text>} />
                <Text size="lg">Important plan information</Text>
                <Text size="sm">{FTCDisclosures.mainText}</Text>
                {requiresNyDisclosures && <Text size="sm">{FTCDisclosures.nyAddendum}</Text>}
                <Checkbox disabled label={<Text>{FTCDisclosures.checkbox2text}</Text>} />
                <Divider />
                <Flex justify="space-between">
                    <Button disabled w="25%">
                        Decline
                    </Button>
                    <Button disabled w="70%">
                        Sign up
                    </Button>
                </Flex>
            </Flex>
        );
    }
};

const GenericSection = ({ label, content }: { label: string; content: string }) => (
    <Flex direction="column" fz="sm">
        <Text fw="bold">{label}</Text>
        <Text>{content}</Text>
    </Flex>
);
